import React, { useCallback, useState, useEffect } from 'react';
import Spinner from 'ui/Spinner';
import { useFetch } from 'hooks';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';

const ApiKeys = () => {
  const [apiKey, setApiKey] = useState('');
  const [subdomain, setSubdomain] = useState('');
  const { data, loading } = useFetch('/settings/api_webhook_tab');

  const generateApiKey = useCallback(async () => {
    const { apiKey: generatedApiKey } = await request.putJSON(
      routes.SETTINGS.GENERATE_API_KEY,
    );
    setApiKey(generatedApiKey);
  }, [setApiKey]);

  useEffect(() => {
    if (data) {
      const { apiKey: fetchedApiKey, subdomain: fetchedSubdomain } = data;
      setApiKey(fetchedApiKey);
      setSubdomain(fetchedSubdomain);
    }
  }, [data]);

  return (
    <div className="panel_body row">
      <div className="Module col-md-12">
        <h3 className="SettingsContent-heading">
          {t('settings.tab.api_webhook.api_docs')}
        </h3>
        <hr />

        <div className="row">
          <div className="col-md-8">
            <div id="api_keys" className="controls">
              {/* eslint-disable-next-line no-nested-ternary */}
              {loading ? (
                <Spinner />
              ) : apiKey ? (
                <table id="api-table" className="table table-bordered">
                  <tbody>
                    <tr>
                      <th scope="row">Subdomain</th>
                      <td>{subdomain}</td>
                    </tr>
                    <tr>
                      <th scope="row">Api Key</th>
                      <td>{apiKey}</td>
                    </tr>
                  </tbody>
                </table>
              ) : (
                <button
                  type="button"
                  onClick={generateApiKey}
                  className="NewButton NewButton--blue"
                >
                  {t('settings.tab.api_webhook.api_permission')}
                </button>
              )}
              <br />
              <a
                href="http://docs.lessonly.com"
                className="decorated"
                target="_blank"
                rel="noreferrer"
              >
                {t('settings.tab.api_webhook.api_docs')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApiKeys;
